import React, { useEffect, useRef, useState } from 'react';
import Editor from 'react-simple-wysiwyg';
import Button from '../../components/ComponentsV1/Button';
import './WysiwygV1.scss';

export const WysiwygV1 = ({
  value = '',
  error = null,
  onChange = () => {},
  hideSaveButton = false,
}) => {
  const [disabled, setDisabled] = useState(true);
  const [saved, setSaved] = useState(false);
  const [html, setHtml] = useState(value);
  const timerRef = useRef(null);

  const onEditorStateChange = (e) => {
    setHtml(e.target.value);
    setDisabled(false);
    if (hideSaveButton) onChange(e.target.value);
  };

  const saveContent = (event) => {
    event.preventDefault();
    if (!disabled) {
      setDisabled(true);
      setSaved(true);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setSaved(false);
      }, 1000);
      onChange(html);
    }
  };

  useEffect(() => {
    if (value?.trim()) {
      setHtml(value);
    }
  }, [value]);

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  return (
    <div className='col'>
      <Editor
        containerProps={{ style: { height: '400px' } }}
        placeholder='Start typing here...'
        value={html}
        onChange={onEditorStateChange}
        className='editor'
      />
      {!hideSaveButton && (
        <div className='saveContent col tw-z-[500]'>
          <div className='tw-flex tw-flex-col tw-items-end tw-w-full tw-mt-5'>
            {saved && (
              <p className='tw-text-green-700 semiBold'>Saved Content.</p>
            )}
            <Button title='Save' disabled={disabled} onClick={saveContent} />
          </div>
        </div>
      )}
      {error && <p className='red'>{error}</p>}
    </div>
  );
};
